function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import { Row, Button, FullScreenModal } from '../index';

var UserInfo = function (_React$Component) {
  _inherits(UserInfo, _React$Component);

  function UserInfo() {
    _classCallCheck(this, UserInfo);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  UserInfo.prototype.render = function render() {
    var _props = this.props,
        goToPrevious = _props.goToPrevious,
        handleSubmit = _props.handleSubmit,
        invalid = _props.invalid,
        submitting = _props.submitting,
        isUpdating = _props.isUpdating,
        Field = _props.field,
        Input = _props.input;
    return React.createElement(FullScreenModal, {
      goToPrevious: goToPrevious
    }, React.createElement('div', {
      className: 'dd-container'
    }, React.createElement(Row, null, React.createElement('div', {
      className: 'dd-fullscreen-modal-container'
    }, React.createElement('div', {
      className: 'dd-fullscreen-modal-title'
    }, 'Update User Info'), React.createElement('form', {
      onSubmit: handleSubmit
    }, React.createElement(Field, {
      name: 'password',
      component: Input,
      label: 'Current Password',
      placeholder: 'Current Password'
    }), React.createElement(Field, {
      name: 'new_password',
      component: Input,
      label: 'New Password',
      placeholder: 'New Password'
    }), React.createElement(Row, {
      className: 'dd-fixed-btns'
    }, React.createElement('div', {
      className: 'dd-fixed-btns-container'
    }, React.createElement('div', {
      className: 'dd-pr-1 dd-fixed-btn dd-fixed-btn-cancel'
    }, React.createElement('div', {
      onClick: function onClick() {
        return goToPrevious();
      },
      className: 'dd-btn dd-btn-primary-outline dd-btn-md'
    }, 'Cancel')), React.createElement('div', {
      className: 'dd-fixed-btn'
    }, React.createElement(Button, {
      text: 'Save',
      color: 'primary',
      disabled: invalid || submitting,
      loading: isUpdating
    })))))))));
  };

  return UserInfo;
}(React.Component);

var UserInfoReduxFormContainer = function UserInfoReduxFormContainer(reduxForm) {
  return reduxForm({
    form: 'userInfoForm',
    validate: function validate(values) {
      var errors = {};

      if (!values.password) {
        errors.password = 'Required';
      }

      if (!values.new_password) {
        errors.new_password = 'Required';
      }

      return errors;
    }
  })(UserInfo);
};

export default UserInfoReduxFormContainer;